<!--
 * @Author: taosong
 * @Date: 2021-03-03 15:24:55
 * @LastEditors: taosong
 * @LastEditTime: 2021-03-30 13:35:26
 * @Description: taosongs
-->
<template>
  <div class="report-explain">
    <span class="explain">报告说明</span>
    <div class="explain-container">
      <span v-html="reportExplainObjCopy ? reportExplainObjCopy : reportExplainObj"></span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
export default {
  name: 'CommonReportExplain',
  props: {
    reportExplainObjCopy: {
      typr: String,
      default: ''
    }
  },
  setup (props) {
    // 定义store
    const store = useStore()
    const reportExplainObj = computed(() => store.state.productMsg.desc)
    return {
      reportExplainObj
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'scss/color.scss';
.report-explain {
  display: flex;
  flex: 1;
  overflow-y: auto;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  padding: 0 30px 10% 30px;
  box-sizing: border-box;
  .explain {
    color: #666;
    font-size: 28px;
    margin: 15px 0;
  }
  .explain-container {
    display: flex;
    flex-direction: column;
    font-size: 26px;
    color: $color-gray;
    span {
      line-height: 40px;
    }
  }
}
</style>
